import { useState } from 'react';

// Small (i) icon that explains a setting in a tooltip on hover and keyboard
// focus (issue #118). Usage: <InfoTip tip="What this setting does." /> placed
// inline after a field label. The tip text doubles as the accessible label so
// screen readers announce the explanation directly on the button.
const InfoTip = ({ tip }) => {
  const [open, setOpen] = useState(false);

  return (
    <span style={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle', marginLeft: '6px' }}>
      <button
        type="button"
        aria-label={tip}
        tabIndex={0}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        style={{
          background: 'transparent', border: 'none', padding: 0, margin: 0,
          cursor: 'help', color: 'var(--muted)', display: 'inline-flex',
          alignItems: 'center', lineHeight: 0,
        }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
      </button>
      {open && (
        <span
          role="tooltip"
          style={{
            position: 'absolute', bottom: 'calc(100% + 8px)', left: '50%',
            transform: 'translateX(-50%)', zIndex: 30,
            width: 'max-content', maxWidth: 'min(260px, 78vw)',
            background: 'var(--surface-card)',
            border: '1px solid var(--hairline)',
            borderRadius: 'var(--radius-md)',
            boxShadow: 'var(--shadow-md)',
            padding: '8px 10px',
            fontFamily: 'var(--font-sans)', fontSize: '12.5px', fontWeight: 400,
            color: 'var(--body-text)', lineHeight: 1.45,
            textTransform: 'none', letterSpacing: 0, textAlign: 'left',
            whiteSpace: 'normal',
          }}
        >
          {tip}
        </span>
      )}
    </span>
  );
};

export default InfoTip;
